export const toggler = (state, action) => {
  switch (action.type) {
    case 'toggleState':
      return { show: !state.show };
    default:
      return null;
  }
};
